import { MatSnackBar } from '@angular/material/snack-bar';
import { first, map, tap } from 'rxjs/operators';
import { PhAuthService } from './ph-auth.service';

export const NO_ACCESS_MSG = $localize`You do not have permissions to access this section.`;

import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

export const ScopesGuard: CanActivateFn = (route) => {
  const required = route.data.requiredScopes;
  const dialog = inject(MatSnackBar);
  return inject(PhAuthService).scopes$.pipe(
    first(),
    map((scopes) => !required || required.every((s) => scopes.includes(s))),
    tap((access) => {
      if (!access) {
        dialog.open(NO_ACCESS_MSG, $localize`Close`, { duration: 10000 });
      }
    })
  );
};
